import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { APP_CONFIG } from '../../../app.config';

@Injectable({
  providedIn: 'root'
})
export class CompoundService {

  REST_API: string = APP_CONFIG.API_ENDPOINT;
  API_URL = `${this.REST_API}`;
  REST_No_API: string = APP_CONFIG.NO_API_ENDPOINT;
  NO_API_URL = `${this.REST_No_API}`;

  constructor(private http: HttpClient) { }


  getAllCompounds(): Observable<any> {
    return this.http.get(this.NO_API_URL+'/propertyManagement/showCompounds')
      .pipe(
        catchError(this.handleError)
      )
  }

  getAllCompoundsDataTable(data:any): any {
    return this.http.post(this.API_URL+'/compounds/findAllCompounds',data)
      .pipe(
        catchError(this.handleError)
      )
  }

  addCompound(data: any): Observable<any> {
    return this.http.post(this.API_URL+'/compounds/createCompoundNG',data)
      .pipe(
        catchError(this.handleError)
      )
  }
  
  updateCompound(data: any): Observable<any> {
    return this.http.post(this.API_URL+'/compounds/updateCompound',data)
      .pipe(
        catchError(this.handleError)
      )
  }

  getCompoundForSelect(): Observable<any> {
    return this.http.get(this.NO_API_URL+'/propertyManagement/showIdAndNamesCompounds')
      .pipe(
        catchError(this.handleError)
      )
  }

  getCompoundAttachment(data:any): Observable<any> {
    return this.http.get(this.API_URL+'/compounds/findAllCompoundDocs'+this.jsonToQueryString(data))
      .pipe(
        catchError(this.handleError)
      )
  }

  getCompundDetails(data): Observable<any> {
    return this.http.get(this.NO_API_URL+'/propertyManagement/showCompoundDetails'+this.jsonToQueryString(data))
      .pipe(
        catchError(this.handleError)
      )
  }

  getCompoundOnwers(data): Observable<any> {
    return this.http.get(this.NO_API_URL+'/propertyManagement/showCompoundOwners'+this.jsonToQueryString(data))
      .pipe(
        catchError(this.handleError)
      )
  }

  deleteCompound(data): Observable<any> {
    return this.http.post(this.API_URL+'/compounds/deleteCompound', data)
      .pipe(
        catchError(this.handleError)
      )
  }

  deleteCompoundsDoc(data): Observable<any> {
    return this.http.post(this.API_URL+'/compounds/deleteCompoundDoc', data)
      .pipe(
        catchError(this.handleError)
      )
  }

  addِCompoundsDoc(data): Observable<any> {
    return this.http.post(this.API_URL+'/compounds/createCompoundDoc', data)
      .pipe(
        catchError(this.handleError)
      )
  }
  
  // Error 
  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Handle client error
      errorMessage = error.error.message;
    } else {
      // Handle server error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    if(error.message.includes('login')){
      localStorage.removeItem('user');
      localStorage.removeItem('sessionID');
      localStorage.removeItem('token');
      window.location.reload();
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  jsonToQueryString(json) {
    return '?' + 
        Object.keys(json).map(function(key) {
            return encodeURIComponent(key) + '=' +
                encodeURIComponent(json[key]);
        }).join('&');
  }
}
